"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopListenerService = void 0;
const listenerToken_1 = require("../support/listenerToken");
class TopListenerService {
    constructor() {
        this.registry = new Map();
    }
    async register(callback) {
        const token = await listenerToken_1.generateListenerToken();
        this.registry.set(token, callback);
        return token;
    }
    remove(token) {
        this.registry.delete(token);
    }
    onTopList(topList) {
        this.registry.forEach(cb => setTimeout(() => cb(topList), 0));
    }
}
exports.TopListenerService = TopListenerService;
//# sourceMappingURL=TopListenerService.js.map